import React, { createContext, Dispatch, ReactElement, ReactNode, SetStateAction, useState } from 'react';
import { FmtpPage } from 'src/components/common/NavigationMenu/types';

export interface SideNavContextShape {
    selectedSideNavItem: string;
    setSelectedSideNavItem: Dispatch<SetStateAction<string>>;
    sideNavPages: FmtpPage[];
    setSideNavPages: Dispatch<SetStateAction<FmtpPage[]>>;
}

const initialContext: SideNavContextShape = {
    selectedSideNavItem: '',
    setSelectedSideNavItem: (): void => undefined,
    sideNavPages: [],
    setSideNavPages: (): void => undefined,
};

// Create a context
const SideNavContext = createContext(initialContext);

// Create a provider component
const SideNavContextProvider = ({ children }: { children: ReactElement | ReactNode | ReactNode[] }) => {
    const [selectedSideNavItem, setSelectedSideNavItem] = useState('');
    const [sideNavPages, setSideNavPages] = useState<FmtpPage[]>([]);

    return (
        <SideNavContext.Provider value={{ selectedSideNavItem, setSelectedSideNavItem, sideNavPages, setSideNavPages }}>
            {children}
        </SideNavContext.Provider>
    );
};

export { SideNavContext, SideNavContextProvider };
